module.exports = __webpack_public_path__ + "img/DUPS-Logo.f49ed931.png";